import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categoryData } from '@/mocks/categories';

export default function Navbar() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 md:px-10">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link
            to="/"
            className={`text-xl md:text-2xl font-heading font-bold tracking-wide whitespace-nowrap ${
              scrolled ? 'text-foreground-900' : 'text-white'
            }`}
          >
            yoybuy.cyou
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                scrolled ? 'text-foreground-700 hover:text-foreground-950' : 'text-white/90 hover:text-white'
              }`}
            >
              Главная
            </Link>
            <Link
              to="/yoybuy-sheet-guide"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                scrolled ? 'text-foreground-700 hover:text-foreground-950' : 'text-white/90 hover:text-white'
              }`}
            >
              Руководство
            </Link>
            <a
              href="#categories"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                scrolled ? 'text-foreground-700 hover:text-foreground-950' : 'text-white/90 hover:text-white'
              }`}
            >
              Категории
            </a>
          </div>

          <div className="flex items-center gap-2 md:gap-3">
            <div className="relative" ref={dropdownRef}>
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className={`flex items-center gap-1.5 px-3 py-2 text-sm font-medium rounded-full border transition-all whitespace-nowrap cursor-pointer ${
                  scrolled
                    ? 'border-foreground-300 text-foreground-700 hover:border-foreground-500'
                    : 'border-white/50 text-white hover:border-white hover:bg-white/10'
                }`}
              >
                Категории
                <i className={`${dropdownOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} text-xs transition-transform`}></i>
              </button>

              {dropdownOpen && (
                <div className="absolute right-0 mt-2 w-56 bg-background-50 rounded-xl shadow-lg border border-background-200 py-2 max-h-80 overflow-y-auto z-50">
                  {categoryData.map((cat) => (
                    <a
                      key={cat.nameEn}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-100 hover:text-primary-700 transition-colors cursor-pointer"
                      onClick={() => setDropdownOpen(false)}
                    >
                      <span className="w-5 h-5 flex items-center justify-center">
                        <i className={`${cat.icon} text-base`}></i>
                      </span>
                      {cat.name}
                    </a>
                  ))}
                </div>
              )}
            </div>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="hidden sm:inline-flex items-center gap-1.5 px-4 py-2 text-sm font-medium rounded-full border transition-all whitespace-nowrap cursor-pointer border-white/60 text-white hover:bg-white hover:text-foreground-900"
            >
              yoybuy sheet
              <i className="ri-arrow-right-up-line text-xs"></i>
            </a>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-1.5 px-4 py-2 text-sm font-semibold rounded-full transition-all whitespace-nowrap cursor-pointer bg-accent-500 text-white hover:bg-accent-600"
            >
              buy it now
              <i className="ri-arrow-right-up-line text-xs"></i>
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}